(() => {
  const header = document.querySelector('[data-cb-header]');
  if (!header) return;

  const onScroll = () => {
    header.classList.toggle('is-scrolled', window.scrollY > 8);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  const burger = header.querySelector('[data-cb-burger]');
  const overlay = document.querySelector('[data-cb-overlay]');
  const close = document.querySelector('[data-cb-drawer-close]');

  const setOpen = (open) => {
    document.documentElement.classList.toggle('cb-mobile-open', open);
    if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  if (burger) burger.addEventListener('click', () => {
    setOpen(!document.documentElement.classList.contains('cb-mobile-open'));
  });
  if (overlay) overlay.addEventListener('click', () => setOpen(false));
  if (close) close.addEventListener('click', () => setOpen(false));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') setOpen(false);
  });

  document.addEventListener('cb:cart:updated', (e) => {
    const count = header.querySelector('[data-cb-cart-count]');
    if (count && e.detail && e.detail.item_count != null) {
      const n = e.detail.item_count;
      count.textContent = n;
      count.toggleAttribute('hidden', n === 0);
    }
  });
})();
